import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import bookingAcceptedConsentsApi from '@/features/dashboard/bookings/api/bookingAcceptedConsentsApi.ts';
import { bookingsApiQueryKeys } from '@/features/dashboard/bookings/api/bookingsApi.queryKeys.ts';
import { messagesApiQueryKeys } from '@/features/dashboard/messages/api/messagesApi.queryKeys.ts';

export const useSendConsentRequest = (bookingId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => bookingAcceptedConsentsApi.requestSignature(bookingId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: bookingsApiQueryKeys.acceptedConsents(bookingId),
      });
      queryClient.invalidateQueries({
        queryKey: messagesApiQueryKeys.byBooking(bookingId),
      });
      toast.success('Wysłano prośbę o podpis', {
        description:
          'Zapisujący dostał e-mail z linkiem do podsumowania rezerwacji.',
      });
    },
    onError: (error: Error) =>
      toast.error('Nie udało się wysłać prośby o podpis', {
        description: error.message,
      }),
  });
};
